export const formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) return "0 Bytes";

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
};

export const formatDate = (date, format = "YYYY-MM-DD") =>
    !date || typeof date === "string" ? date : date.format(format);

export const displayFullName = (person) => {
    if (!person) {
        return "Not specified";
    }

    const title = person.title || "";
    const firstName = person.firstName || "";
    const initials = person.initials || "";
    const lastName = person.lastName || "";

    return `${title} ${firstName} ${initials} ${lastName}`.trim();
};
